module.exports = __webpack_public_path__ + "img/collar_buttons_quantity.f5622e6c.png";